import React from "react";
import {Box, Checkbox, FormControlLabel, TextField, Typography} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";

export const SettingsRefactoredTab = ({node, setNode, onUpdate}) => {

    const onChangeData = (key, value) => {
        setNode(prev => {
            const state = {...prev};
            state.data[key] = value;
            return state;
        })
    }

    const {primary, secondary} = menuItemsInfo.settings_refactored;

    return (
        <>
            <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
                <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
                <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
            </Box>

            <TextField
                value={node?.data?.max_ttl || ""}
                size={"small"}
                type={"number"}
                label={"Max TTL"}
                placeholder={"Enter number"}
                helperText={"Maximum attempts to understand user"}
                onChange={e => onChangeData("max_ttl", e.target.value)}
                onBlur={() => onUpdate(node)}
            />
            <Box sx={{px: 1}}>
                <FormControlLabel
                    size={"small"}
                    control={(
                        <Checkbox checked={!!node?.data?.hint} size={"small"} sx={{p: 0.5}}
                                  onChange={(event => onChangeData("hint", event.target.checked))}
                                  onBlur={() => onUpdate(node)}/>
                    )} label={`Use Hint`}
                />
            </Box>
            <Box sx={{px: 1}}>
                <FormControlLabel
                    size={"small"}
                    control={(
                        <Checkbox checked={!!node?.data?.share_conversation_context} size={"small"} sx={{p: 0.5}}
                                  onChange={(event => onChangeData("share_conversation_context", event.target.checked))}
                                  onBlur={() => onUpdate(node)}/>
                    )} label={`Share Conversation Context`}
                />
            </Box>
            <TextField
                type={"number"}
                value={node?.data?.conversation_buffer_window}
                size={"small"}
                label={"Conversation buffer window"}
                placeholder={"Buffer window"}
                helperText={node?.data?.share_conversation_context ? "" : "Only used when context sharing is on"}
                onChange={(e) => onChangeData('conversation_buffer_window', e.target.value)}
                onBlur={() => onUpdate(node)}
            />
        </>
    )
}